import React, { useEffect, useState } from 'react';
import { View, Pressable } from 'react-native';
import { useQuery, useLazyQuery } from '@apollo/client';
import { Prohibit } from '@phosphor-icons/react';

import { Button } from 'app/src/elements/buttons';
import { ICON_SIZES } from 'app/src/elements/Icon';
import colors from 'app/src/styles/colors';
import { Container, ButtonContainer } from 'app/src/elements/ButtonPicker';
import { StyledTextInput, FieldLabel } from 'app/src/elements/inputs';
import { Text, Subtitle } from 'app/src/styles';

import { EVENT_TYPES } from './queries';

export const SelectedEventTypeActions = props => {
  const { eventType, selectedEventType, setValues } = props;

  return (
    <Pressable
      onPress={() => setValues(eventType, { selected: false })}
      accessibilityLabel="Remove selection"
    >
      <Prohibit
        size={ICON_SIZES.button}
        weight="regular"
        color={colors.textMuted}
      />
    </Pressable>
  );
};

export const SelectedEventTypeButton = props => {
  const { eventType, selectedEventType, setValues } = props;

  return (
    <ButtonContainer
      onPress={() => (
        selectedEventType.selected ?
          null : setValues(eventType, { selected: true })
      )}
      notSelected={!selectedEventType.selected}
    >
      <Text style={{ fontSize: 40 }}>
        {eventType.emoji || eventType.name[0]}
      </Text>
      <Text style={{ fontSize: 13 }}>
        {eventType.name}
      </Text>

      {selectedEventType.selected && (
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'space-around',
            width: '100%'
          }}
        >
          <SelectedEventTypeActions {...props} />
        </View>
      )}
    </ButtonContainer>
  );
};

export const SelectedEventTypeListItem = props => {
  const { eventType, selectedEventType } = props;

  return (
    <View style={{ flexDirection: 'row', gap: 20 }}>
      <Text>{eventType.name}</Text>

      {!!selectedEventType.notes && (
        <Text style={{ fontStyle: 'italic' }}>{selectedEventType.notes}</Text>
      )}

      <SelectedEventTypeActions {...props} />
    </View>
  );
};

const SelectedEventTypes = props => {
  const {
    selected: selectedEventTypes,
    setSelected: setSelectedEventTypes,
  } = props;

  const [showButtons, setShowButtons] = useState(props.showButtons);

  const [eventTypes, setEventTypes] = useState();

  const { data } = useQuery(EVENT_TYPES, {
    variables: { limit: 999999, offset: "MA==", options: {} }
  });

  useEffect(() => {
    if (data) { setEventTypes(data.eventTypes.edges.map(edge => edge.node)); }
  }, [data]);

  if (!eventTypes) { return null; }

  const selectedEventType = eventType => (
    selectedEventTypes[eventType.id] || { eventTypeId: eventType.id }
  );

  const setValues = (eventType, values) => {
    const selectedEventTypeData =
      { ...selectedEventType(eventType), ...values };

    setSelectedEventTypes({
      ...selectedEventTypes,
      [eventType.id]: selectedEventTypeData
    });
  };

  const selectedSelectedEventTypes = Object.keys(selectedEventTypes)
    .map(eventTypeId => selectedEventTypes[eventTypeId])
    .filter(selectedEventType => selectedEventType?.selected);

  return (
    <View>
      <Subtitle>Event Types</Subtitle>

      {(!showButtons || eventTypes.length > 0) && (
        <Pressable onPress={() => setShowButtons(!showButtons)}>
          <Text>[{showButtons ? 'Hide' : 'Show'} Selection Buttons]</Text>
        </Pressable>
      )}

      {showButtons && eventTypes && (
        <Container>
          {eventTypes.map(eventType => (
            <SelectedEventTypeButton
              key={eventType.id}
              eventType={eventType}
              selectedEventType={selectedEventType(eventType)}
              setValues={setValues}
            />
          ))}
        </Container>
      )}

      {selectedSelectedEventTypes.map(selectedEventType => (
        <SelectedEventTypeListItem
          key={selectedEventType.eventTypeId}
          eventType={
            eventTypes.find(eventType => (
              eventType.id === selectedEventType.eventTypeId
            ))
          }
          selectedEventType={selectedEventType}
          setValues={setValues}
        />
      ))}
    </View>
  );
};

export default SelectedEventTypes;
